import RoleEntity from '@modules/roles/entity';

class PermissionsEntity {
  resource = '';

  code = '';

  permissions: RoleEntity[] = [];

  constructor(permissions: Partial<PermissionsEntity>) {
    if (!permissions) {
      return;
    }
    Object.assign(this, permissions);
  }

  static createListPermissions(listPermissions: Array<Partial<PermissionsEntity>>) {
    if (!Array.isArray(listPermissions)) {
      return [];
    }
    return listPermissions.map((permissions: Partial<PermissionsEntity>) => {
      return new PermissionsEntity(permissions);
    });
  }
}

export enum PermissionEnum {
  UsersView = 'UsersView',
  UsersViewDetail = 'UsersViewDetail',
  UsersCreate = 'UsersCreate',
  UsersUpdate = 'UsersUpdate',
  UsersDelete = 'UsersDelete',
  RolesView = 'RolesView',
  RolesViewDetail = 'RolesViewDetail',
  RolesCreate = 'RolesCreate',
  RolesUpdate = 'RolesUpdate',
  RolesDelete = 'RolesDelete',
  CollectionsCreate = 'CollectionsCreate',
  CollectionsDelete = 'CollectionsDelete',
  CollectionsView = 'CollectionsView',
  CollectionsViewDetail = 'CollectionsViewDetail',
  CollectionsUpdate = 'CollectionsUpdate',
  CustomersCreate = 'CustomersCreate',
  CustomersDelete = 'CustomersDelete',
  CustomersView = 'CustomersView',
  CustomersViewDetail = 'CustomersViewDetail',
  CustomersUpdate = 'CustomersUpdate',
  DevicesCreate = 'DevicesCreate',
  DevicesDelete = 'DevicesDelete',
  DevicesView = 'DevicesView',
  DevicesViewDetail = 'DevicesViewDetail',
  DevicesUpdate = 'DevicesUpdate',
  DevicesCollectView = 'DevicesCollectView',
  DevicesFullContainerHistoryView = 'DevicesFullContainerHistoryView',
  EventsCreate = 'EventsCreate',
  EventsDelete = 'EventsDelete',
  EventsView = 'EventsView',
  EventsViewDetail = 'EventsViewDetail',
  EventsUpdate = 'EventsUpdate',
  ItemGroupsCreate = 'ItemGroupsCreate',
  ItemGroupsDelete = 'ItemGroupsDelete',
  ItemGroupsView = 'ItemGroupsView',
  ItemGroupsViewDetail = 'ItemGroupsViewDetail',
  ItemGroupsUpdate = 'ItemGroupsUpdate',
  ItemsCreate = 'ItemsCreate',
  ItemsDelete = 'ItemsDelete',
  ItemsView = 'ItemsView',
  ItemsViewDetail = 'ItemsViewDetail',
  ItemsUpdate = 'ItemsUpdate',
  OtherGiftsCreate = 'OtherGiftsCreate',
  OtherGiftsDelete = 'OtherGiftsDelete',
  OtherGiftsView = 'OtherGiftsView',
  OtherGiftsViewDetail = 'OtherGiftsViewDetail',
  OtherGiftsUpdate = 'OtherGiftsUpdate',
  OtherGiftsTransfer = 'OtherGiftsTransfer',
  OtherGiftsDistribute = 'OtherGiftsDistribute',
  RankingGiftsCreate = 'RankingGiftsCreate',
  RankingGiftsDelete = 'RankingGiftsDelete',
  RankingGiftsView = 'RankingGiftsView',
  RankingGiftsViewDetail = 'RankingGiftsViewDetail',
  RankingGiftsUpdate = 'RankingGiftsUpdate',
  RankingGiftsTransfer = 'RankingGiftsTransfer',
  SettingsUpdate = 'SettingsUpdate',
  SettingsView = 'SettingsView',
  CustomerCollectionHistoriesView = 'CustomerCollectionHistoriesView',
  DevicesCollectionHistoryCreate = 'DevicesCollectionHistoryCreate',
  DevicesCollectionHistoryView = 'DevicesCollectionHistoryView',
  ItemsPurchaseHistoriesView = 'ItemsPurchaseHistoriesView',
  ItemsChangeStatus = 'ItemsChangeStatus',
  ErrorsUpdate = 'ErrorsUpdate',
  ErrorsView = 'ErrorsView',
  ErrorsViewDetail = 'ErrorsViewDetail',
  OtherGiftsVouchersCreate = 'OtherGiftsVouchersCreate',
  OtherGiftsVouchersDelete = 'OtherGiftsVouchersDelete',
  OtherGiftsVouchersView = 'OtherGiftsVouchersView',
  OtherGiftsVouchersUpdate = 'OtherGiftsVouchersUpdate',
  RankingGiftsVouchersCreate = 'RankingGiftsVouchersCreate',
  RankingGiftsVouchersDelete = 'RankingGiftsVouchersDelete',
  RankingGiftsVouchersView = 'RankingGiftsVouchersView',
  RankingGiftsVouchersUpdate = 'RankingGiftsVouchersUpdate',
  VoucherTypes = 'VoucherTypes',
  VoucherTypesCreate = 'VoucherTypesCreate',
  VoucherTypesDelete = 'VoucherTypesDelete',
  VoucherTypesView = 'VoucherTypesView',
  VoucherTypesUpdate = 'VoucherTypesUpdate',
  VoucherTypesViewDetail = 'VoucherTypesViewDetail',
  DashboardsView = 'DashboardsView',
  DevicesCollectionHistoriesView = 'DevicesCollectionHistoriesView',
  DevicesCollectionHistoriesViewDetail = 'DevicesCollectionHistoriesViewDetail',
  CustomerGiftsRevoke = 'CustomerGiftsRevoke',
  PurchaseHistoriesRevoke = 'PurchaseHistoriesRevoke',
  CustomersPurchaseHistoriesRevoke = 'CustomersPurchaseHistoriesRevoke',
  CustomersGiftsRevoke = 'CustomersGiftsRevoke',
  CustomersCollectionHistoriesView = 'CustomersCollectionHistoriesView',
  CustomersVoucherStoragesView = 'CustomersVoucherStoragesView',
  CustomersPurchaseHistoriesView = 'CustomersPurchaseHistoriesView',
  CustomersLeaderboardHistoriesView = 'CustomersLeaderboardHistoriesView',
  CustomersGiftStoragesView = 'CustomersGiftStoragesView',
  OverallView = 'OverallView',
  WeeklyView = 'WeeklyView',
  WeeklyDistribute = 'WeeklyDistribute',
  ReportsView = 'ReportsView',
  DeviceGroupsCreate = 'DeviceGroupsCreate',
  DeviceGroupsDelete = 'DeviceGroupsDelete',
  DeviceGroupsView = 'DeviceGroupsView',
  DeviceGroupsViewDetail = 'DeviceGroupsViewDetail',
  DeviceGroupsUpdate = 'DeviceGroupsUpdate',

  ExchangeGiftsView = 'ExchangeGiftsView',
  ExchangeGiftsCreate = 'ExchangeGiftsCreate',
  ExchangeGiftsDelete = 'ExchangeGiftsDelete',
  ExchangeGiftsTransfer = 'ExchangeGiftsTransfer',
  ExchangeGiftsUpdate = 'ExchangeGiftsUpdate',
  ExchangeGiftsViewDetail = 'ExchangeGiftsViewDetail',
  ExchangeGiftsVouchersCreate = 'ExchangeGiftsVouchersCreate',
  ExchangeGiftsVouchersDelete = 'ExchangeGiftsVouchersDelete',
  ExchangeGiftsVouchersUpdate = 'ExchangeGiftsVouchersUpdate',
  ExchangeGiftsVouchersView = 'ExchangeGiftsVouchersView',

  CustomersCoinTransactionView = 'CustomersCoinTransactionView',
  CustomersGiftsReturn = 'CustomersGiftsReturn',
  CustomersPurchaseHistoriesReturn = 'CustomersPurchaseHistoriesReturn',
  CustomersGuardGroupParticipantsCreate = 'CustomersGuardGroupParticipantsCreate',
  CustomersGuardGroupParticipantsDelete = 'CustomersGuardGroupParticipantsDelete',
  CustomersGuardGroupParticipantsView = 'CustomersGuardGroupParticipantsView',
  CustomersGuardGroupsViewActive = 'CustomersGuardGroupsViewActive',
  DevicesCollectionHistoriesUpdate = 'DevicesCollectionHistoriesUpdate',
  Monthly = 'Monthly',
  MonthlyView = 'MonthlyView',
  GuardGroups = 'GuardGroups',
  GuardGroupsCreate = 'GuardGroupsCreate',
  GuardGroupsDelete = 'GuardGroupsDelete',
  GuardGroupsUpdate = 'GuardGroupsUpdate',
  GuardGroupsView = 'GuardGroupsView',
  GuardGroupsViewDetail = 'GuardGroupsViewDetail',
  Guards = 'Guards',
  GuardsCreate = 'GuardsCreate',
  GuardsDelete = 'GuardsDelete',
  GuardsUpdate = 'GuardsUpdate',
  GuardsView = 'GuardsView',
  GuardsViewDetail = 'GuardsViewDetail',
  CustomersGuardGroupParticipantsUpdate = 'CustomersGuardGroupParticipantsUpdate',
  RewardItemsCreate = 'RewardItemsCreate',
  RewardItemsView = 'RewardItemsView',
  RewardItemsViewDetail = 'RewardItemsViewDetail',
  RewardItemsUpdate = 'RewardItemsUpdate',
  RewardItemsDelete = 'RewardItemsDelete',
  DeviceRewardItemsRefill = 'DeviceRewardItemsRefill',
  DeviceRewardItemsView = 'DeviceRewardItemsView',
  RewardRedemptionsView = 'RewardRedemptionsView',
  RewardRedemptionsViewDetail = 'RewardRedemptionsViewDetail',
  RewardRedemptionsRefund = 'RewardRedemptionsRefund',
}

export default PermissionsEntity;
